import { render, staticRenderFns } from "./CardHalfWidth.vue?vue&type=template&id=81604070&scoped=true&"
import script from "./CardHalfWidth.vue?vue&type=script&lang=js&"
export * from "./CardHalfWidth.vue?vue&type=script&lang=js&"
import style0 from "./CardHalfWidth.vue?vue&type=style&index=0&id=81604070&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81604070",
  null
  
)

component.options.__file = "CardHalfWidth.vue"
export default component.exports